import _ from 'lodash';
import * as pm from './postMessage';
import platformUtils from './platformUtils';
import appStudioUtils from './utils/appStudioUtils';
import {generateError} from './validations/errors';
import monitoring from './monitoring';

const onReadyCallbacks = [];
const onRenderCallbacks = [];
const ready = new Set();

function wrapCallbackWithTimer(callback, id) {
    return () => {
        const startTime = Date.now();
        const result = callback();
        if (result instanceof Promise) {
            result.then(() => {
                console.log(`${id} was delayed by ${Date.now() - startTime}ms due to code`);
            });
        }
        return result;
    };
}

function safeRun(callback) {
    try {
        return callback();
    } catch (e) {
        console.error(e);
        return;
    }
}

function on(callback, callbacksArr, log, type) {
    platformUtils.wSpyLog('readyManager', [`on-${type}`, callback, callbacksArr]);
    if (!_.isFunction(callback)) {
        const functionName = `on${_.capitalize(type)}`;
        throw new monitoring.MonitoringErrorToIgnore(generateError.error_type({
            functionName,
            propertyName: `${functionName}Handler`,
            wrongValue: callback,
            expectedType: 'function'
        }));
    }

    const actualCallback = log ? wrapCallbackWithTimer(callback, log) : callback;
    if (ready.has(type)) {
        _.defer(() => safeRun(actualCallback));
    }

    callbacksArr.push(actualCallback);
}

function trigger(success, callbacksArr, type) {
    platformUtils.wSpyLog('readyManager', [`trigger-${type}-activate`, callbacksArr, success]);
    const allReady = Promise.all(callbacksArr.map((cb) => safeRun(cb))).then((res) => {
        const items = _.remove(res, (item) => !(_.isUndefined(item) || _.has(item, 'controllerId')));
        platformUtils.wSpyLog('readyManager', [`trigger-${type}-after-all-ready`, items]);
        _.forEach(items, (data) => pm.sendMessageToHost(pm.Intent.WIX_CODE_WARMUP, {
            command: pm.MessageTypes.SET_WARMUP_DATA,
            data: {
                controllerId: 'wix-code',
                data
            }
        }));
    }).catch((reason) => {
        platformUtils.wSpyLog('readyManager', [`trigger-${type}-error`, reason]);
        console.error(reason);
    });
    if (success) {
        allReady.then(() => success());
    }

    callbacksArr.length = 0;
}

export function onReady(callback, log) {    
    on(callback, onReadyCallbacks, log, 'ready');
}

export function triggerOnReady(success) {

    ready.add('ready');
    const RMI = platformUtils.getRMI();
    const props = RMI.getWidgetProperties();
    appStudioUtils.addAppStudioWidgetPropsToSelector(props);
    onReadyCallbacks.push(() => {platformUtils.addQueryParameters({renderCycle: NaN});});
    trigger(success, onReadyCallbacks, 'onReady');

}

export function onRender(callback, log) {
    on(callback, onRenderCallbacks, log, 'render');
}

export function triggerOnRender(success) {
    ready.add('render');
    trigger(success, onRenderCallbacks, 'render');
}

export function clearReadyManager() {
    onReadyCallbacks.splice(0);
    onRenderCallbacks.splice(0);
    ready.clear();
}
